import { useMutation, useQueryClient } from '@tanstack/react-query'
import { connect } from 'getstream'
import { streamApi, supabase } from '../../api'

const doFollow = async (
  id: number | string,
) => {
  const { data: userData } = await supabase.auth.getSession()
  const userId = userData?.session?.user.id

  if (!userData?.session?.user?.id) {
    return null
  }

  const { data: isFollowed } = await supabase
    .from('following_users')
    .select('*')
    .eq('user_id', userData?.session?.user?.id)
    .eq('follow_user_id', id)
    .maybeSingle()

  if (isFollowed) {
    return null
  }

  const REACT_APP_STREAM_API_KEY: string = process.env.REACT_APP_STREAM_API_KEY || ''
  const REACT_APP_STREAM_APP_ID: string = process.env.REACT_APP_STREAM_APP_ID || ''

  const result = await streamApi.post(
    '/getToken',
    { id: userId || 'anonymous' },
  )
  const client = connect(
    REACT_APP_STREAM_API_KEY,
    result.token,
    REACT_APP_STREAM_APP_ID,
  )

  const userNotificationsFeed = await client.feed(
    'notification',
    userId,
  );

  const userFeed = await client.feed(
    'user_feed',
    userId,
  );

  const { data: postData, error } = await supabase
    .from('following_users')
    .insert({
      user_id: userData?.session?.user?.id,
      follow_user_id: id,
    })
    .select()
    .single()

  userNotificationsFeed.follow('user', `${id}`, { limit: 0 })
  userFeed.follow('user', `${id}`)
  // notification
  const { data: profile } = await supabase
    .from('user_profiles')
    .select(`
        *,
        expertProfile:salons_profile (*),
        privacy:profile_privacy_activity (id, activity, enabled)
      `)
    .eq('id', userId)
    .single();

  const myActivityFeed = await client.feed(
    'user_activity',
    userId,
  );
  // notification
  const activity = {
    message: `@${profile?.username} started following to you`,
    verb: 'following',
    object: `user:${userData.session?.user.id}`,
    to: [`notification:${id}`],
    user: profile,
  }; // @ts-ignore
  await myActivityFeed.addActivity(activity)

  if (error) {
    throw new Error(error.message)
  }

  return postData
}

const doUnFollow = async (
  id: number | string,
) => {
  const { data: userData } = await supabase.auth.getSession()
  const userId = userData?.session?.user.id
  const REACT_APP_STREAM_API_KEY: string = process.env.REACT_APP_STREAM_API_KEY || ''
  const REACT_APP_STREAM_APP_ID: string = process.env.REACT_APP_STREAM_APP_ID || ''

  const result = await streamApi.post(
    '/getToken',
    { id: userId || 'anonymous' },
  )
  const client = connect(
    REACT_APP_STREAM_API_KEY,
    result.token,
    REACT_APP_STREAM_APP_ID,
  )

  const userNotificationsFeed = await client.feed(
    'notification',
    userId,
  );
  const userFeed = await client.feed(
    'user_feed',
    userId,
  );

  if (userData?.session?.user?.id === id) {
    throw new Error('You will not be able to subscribe to yourself')
    return null
  }

  const { error } = await supabase
    .from('following_users')
    .delete()
    .eq('user_id', userData?.session?.user?.id)
    .eq('follow_user_id', id);

  if (error) {
    throw new Error(error.message)
  }

  userNotificationsFeed.unfollow('user', `${id}`)
  userFeed.unfollow('user', `${id}`)

  return null
}

export default function useFollowUser(
  id: number | string,
) {
  const queryClient = useQueryClient()

  return useMutation((follow: boolean) => (follow ? doFollow(id) : doUnFollow(id)), {
    onSuccess: async (res) => {
      queryClient.invalidateQueries(['useUserIsFollowedByMe', id])
      queryClient.invalidateQueries(['userFollowingCount', id])
      return res
    },
  })
}
